module.exports = __webpack_public_path__ + "img/square_rounded_opaque.7005357e.svg";